import React, { FC, ReactElement } from 'react';
import './ingridientNameField.scss';
import COSelectSearch from 'shared/components/COSelectSearch';
import { useField } from 'formik';
import { Address } from 'models/Address/address.model';
import { RawMaterialPackagingMeta } from 'models/RawMaterialPackagingMeta/rawMaterialPackagingMeta.model';

interface IngridientNameFieldProps {
  name: string;
  label: string;
  placeholder: string;
  onChange?: (value: string) => void;
  dropdownRender?: (menu: ReactElement) => ReactElement;
  disabled: boolean;
  onFocus?: () => void;
  options: RawMaterialPackagingMeta[];
  bestFitRegionName: string;
  ingredientOriginName: string;
  addressName: string;
}

const IngridientNameField: FC<IngridientNameFieldProps> = props => {
  const {
    name,
    label,
    placeholder,
    onChange,
    dropdownRender,
    disabled,
    onFocus,
    options,
    bestFitRegionName,
    ingredientOriginName,
    addressName,
  } = props;

  const [, , helpers] = useField(bestFitRegionName);

  const [, , ingredientOriginHelpers] = useField(ingredientOriginName);

  const [, , addressHelpers] = useField(addressName);

  const onFieldChange = (value: string) => {
    helpers.setValue('', true);
    helpers.setTouched(true);
    ingredientOriginHelpers.setValue('', true);
    ingredientOriginHelpers.setTouched(true);
    addressHelpers.setValue(new Address());
    onChange?.(value);
  };

  return (
    <>
      <COSelectSearch
        name={name}
        label={label}
        placeholderstring={placeholder}
        onChange={onFieldChange}
        options={options}
        dropdownRender={dropdownRender}
        disabled={disabled}
        onFocus={onFocus}
      />
    </>
  );
};

export default IngridientNameField;
